import React from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer } from 'antd';
import { ping } from '../actions/app';
import app_params from '../../../config/params';
import {
  ReloadOutlined,
  LoadingOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';

export default class NetworkErrorAlert extends React.Component {
  constructor(props) {
    super(props);
    this.interval = null;
  }

  state = {
    mode: 'connected', // connected | connecting | disconnected
    retryCount: 0, // meaningful when mode is 'connecting'
  };

  static propTypes = {
    error: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { error: prevError } = prevProps;
    const { error } = this.props;

    if (prevError && !error) { // Error -> Ok transition
      this.setState({ mode: 'connected' });
      this.stopPinging();
    }

    if (!prevError && error) { // Ok -> Error
      this.startPinging();
    }
  }

  startPinging = () => {
    this.setState({
      mode: 'connecting',
      retryCount: 0,
    });
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(this.triggerPing, app_params.NETWORK_RETRY_INTERVAL * 1000);
  }

  stopPinging = () => {
    this.setState({ retryCount: 0 });
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = null;
  }

  triggerPing = () => {
    if (this.state.retryCount > app_params.NETWORK_RETRY_MAX_COUNT) {
      this.stopPinging();
      this.setState({ mode: 'disconnected' });
      return;
    }
    this.props.dispatch(ping());
    this.setState({ retryCount: this.state.retryCount + 1 });
  }

  render() {
    const { mode } = this.state;
    return (
      <Drawer
        closable={false}
        destroyOnClose={true}
        visible={this.props.error}
        placement="top"
        className="network_error_drawer"
        mask={true}
        maskStyle={{ backgroundColor: 'rgba(255,255,255,0.2)' }}
        keyboard={false}
        title={null}
        height={36}
        bodyStyle={{ padding: 0 }}
      >
        <div className="network__error bg-warning d-flex flex-row align-items-center justify-content-center" style={{ height: 36 }}>
          <div className="container-xl d-flex flex-row align-items-center justify-content-between">
            <div className="d-flex flex-row align-items-center">
              <ThunderboltOutlined className="text_network_normal mr-2" style={{ fontSize: 18 }} />
              <div className="text_network_title">Cannot reach PageHits. <span className="d-none d-sm-inline text_network_normal">We'll keep trying but check your Internet connection.</span></div>
            </div>
            <div className="d-flex flex-row align-items-center">
              { mode === 'connecting' ? (
                <div className="d-flex flex-row align-items-center">
                  <div className="text_network_title">Auto-connecting: attempt #{this.state.retryCount + 1}</div>
                  <LoadingOutlined className="text_network_normal ml-2" />
                </div>
              ) : null }
              { mode === 'disconnected' ? (
                <Button size="small" icon={<ReloadOutlined />} type="link" className="text_network_title" onClick={this.startPinging}>Retry</Button>
              ) : null }
            </div>
          </div>
        </div>
      </Drawer>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/NetworkErrorAlert.jsx